import axios from 'axios';

import { DEFAULT_CONFIG } from './constants';

export const createRequest = (config=DEFAULT_CONFIG) => axios.create({
  ...config
})
